module.exports = __webpack_public_path__ + "0360974dad2cefa978a5de3f2c23ce26.pdf";